import React from "react";
import AddDeductTaxTableHead from "./AddDeductTaxTableHead";

/**
 * Table header for the EE & ER Taxes table.
 * Reuses the shared AddDeductTaxTableHead component.
 */
const TaxTableHead = React.memo(function TaxTableHead(props) {
    return <AddDeductTaxTableHead title="EE & ER Taxes" {...props} />;
});

export default TaxTableHead;
